import React from 'react';
import { getEnv } from '@base/utils/helpers';
import { Loader } from '@ui-kit/components/loader';
import { useAsyncData } from '@utils/hooks';
import { container } from 'tsyringe';
import { ITicketService } from '../model/interfaces';
import PaypalProvider from './paypalProvider';
import StripeProvider from './stripeProvider';

export default function PaymentsProvider(props: { children: JSX.Element[] }) {
  const platform = getEnv('NX_PLATFORM');

  switch (platform) {
    case 'WIN':
      return <div>{props.children}</div>;
    case 'MAC':
      return <div>{props.children}</div>;
    default:
      return <FullPayments>{props.children}</FullPayments>;
  }
}

function FullPayments(props: { children: JSX.Element[] }) {
  const ticketsService: ITicketService = container.resolve('ticketsService');
  const { data: clientId } = useAsyncData(() => ticketsService.getPaypalToken());
  const stripePromise = ticketsService.initStripe();

  if (!clientId) return <Loader />;

  return (
    <PaypalProvider clientId={clientId}>
      <StripeProvider stripe={stripePromise}>{props.children}</StripeProvider>
    </PaypalProvider>
  );
}
